import React, { Component, Fragment } from "react";
import Navbar from './Navbar'
import { withRouter } from 'react-router';
import collectionApi from 'src/api/v2/CollectionApi'
import authApi from 'src/api/v2/AuthApi'
import { connect } from 'react-redux';
import { notify } from 'react-notify-toast';
import { sessionCheck } from 'src/actions/user';
import { getCurrentCollection, getPresetsDropdown } from 'src/actions/prioritize';
import { ID_REGEX, EDIT_PAGES_REGEX, NON_OWNER_NOTIFY_ERROR_MSG, isCollectionOwner } from 'src/util/PrioritizeUtil'
import { GLOBAL_PATH_PREFIX } from 'src/constants';
import './Prioritize.module.scss'

class Prioritize extends Component {

  getURLCollectionId = () => {
    const { location } = this.props
    if (!location) return null

    const splitPath = location.pathname.split('/')

    if (splitPath[3].match(ID_REGEX)) return splitPath[3]
    return null
  }

  fetchCollectionToState = async (id) => {
    const collectionDetails = await collectionApi.get({ id })
    this.props.getCurrentCollection(collectionDetails)
  }

  fetchPresets = () => {
    if (!this.props.presets)
      collectionApi.getAllByType('prioritize-factors')
        .then(presets =>
          presets.collectionsError && presets.collectionsError.code === 401
            ? this.props.getPresetsDropdown([])
            : this.props.getPresetsDropdown(presets))
        .catch(error => console.error(error));
  }

  fetchCollection = async () => {
    const { collection } = this.props

    const id = this.getURLCollectionId()
    if (!id || collection) return

    try {
      await this.fetchCollectionToState(id)
    } catch ({ collectionsError }) {

      if (collectionsError.code === 401) {
        const guestUser = await authApi.authGuest()
        console.log("Guest user authenticated", guestUser);

        try {
          await this.fetchCollectionToState(id)
        } catch (error) {
          console.err("Unable to load collection even after a guest session is created", error);
        }
      }

    }
  }

  isEditing = () => {
    const isEditURL = this.props.location.pathname.match(EDIT_PAGES_REGEX)
    return !!isEditURL
  }


  componentDidUpdate = () => {
    const { history, collection } = this.props

    const isOnEditingPage = this.isEditing()
    const isOwner = isCollectionOwner(collection)

    if (this.props.collection && !isOwner && isOnEditingPage) {
      notify.show(NON_OWNER_NOTIFY_ERROR_MSG, 'error', 3000);
      history.push(`${GLOBAL_PATH_PREFIX}/error`)
    }
  }

  componentDidMount = () => {
    const { user, presets, collection } = this.props

    if (!user || !user.user) this.props.sessionCheck(false);

    if (!presets || !presets.length) this.fetchPresets();

    if (!collection) this.fetchCollection();
  }



  render() {
    const { children, step, collection } = this.props
    //Hack, to force highlighting what tab is selected
    const currentTabIdx = step === 3 ? 0 : 1;

    return (
      <Fragment>
        <Navbar collection={collection} currentTabIdx={currentTabIdx} />
        <div className="prioritize container">
          {children}
        </div>
      </Fragment>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    presets: state.prioritize.presets,
    collection: state.prioritize.collection
  };
};

export default withRouter(connect(mapStateToProps, {
  sessionCheck,
  getCurrentCollection,
  getPresetsDropdown
})(Prioritize));
